<template>
  <div class="media" :class="{'deletable': isDeletable}">
    <image-loader :src="media.url" height="80px" width="80px" alt="" />
    <span class="remove" v-if="isDeletable" @click="deleteMedia">
      <font-awesome-icon icon="trash"></font-awesome-icon>
    </span>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  props: {
    mediaid: {
      type: String,
      required: true
    }
  },
  data () {
    return {
    }
  },

  computed: {
    ...mapGetters('medias', {
      getById: 'getById'
    }),

    ...mapGetters('account', {
      lang: 'defaultLang'
    }),

    media () {
      return this.getById(this.mediaid)
    },
    isDeletable () {
      return this.media.deletable === 1
    }
  },
  methods: {
    ...mapActions('medias', ['removeMedia']),

    deleteMedia () {
      this.removeMedia({media: this.media})
    }
  }
}

</script>

<style lang="scss" scoped>
.media.deletable {
  position: relative;

  .remove {
    display: none;
  }

  &:hover {
    &:after {
      content: " ";
      display: block;
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      background: rgba(55,55,55,0.8);
      z-index: 20;
      border-radius: 4px;
    }
    .remove {
      z-index: 21;
      display: block;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      color:#e74c3c;
      background: #fff;
      padding: 8px;
      border-radius: 100%;
      width: 50px;
      height: 50px;
      font-size: 20px;
      line-height: 36px;
      text-align: center;
      box-shadow: 0 2px 2px 0 rgba(0,0,0,0.14),0 3px 1px -2px rgba(0,0,0,0.12),0 1px 5px 0 rgba(0,0,0,0.2);
      cursor: pointer;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/libraries/media.vue